<template>
	<footer class="zov-layout-footer"><slot>Footer</slot></footer>
</template>
<script>
const prefix = 'zov-layout-footer'
export default {
	name: prefix
}
</script>
